<template>
  <div>
    <HeroSection />
    <start-your-project />
    <wave-footer />
  </div>
</template>

<script>
import HeroSection from "@/components/HeroSection";
import StartYourProject from "@/components/StartYourProject";
import WaveFooter from "@/components/WavFooter";

export default {
  name: "Home",
  components: {
    HeroSection,
    StartYourProject,
    WaveFooter,
  },
};
</script>
